import { createSelector } from 'reselect';
import { IWatchedTicker } from '@kattana-io/common';
import { IStore } from '../reducers';
import { IWatchedWallet } from '../reducers/wallet_watchlist';

const createGetFromWatchlist = (id?: number) =>
  createSelector(
    (state: IStore) => state.watchlist.watched,
    (watchlistTickers: IWatchedTicker[]): IWatchedTicker | undefined =>
      watchlistTickers.find((item) => item.id === id)
  );

export type GetWalletFromWatchlistData =
  | {
      type: 'overview';
      walletId: number;
    }
  | {
      type: 'traders';
      chain: string;
      address: string;
    };

const createGetFromWalletsWatchlist = (data: GetWalletFromWatchlistData) =>
  createSelector(
    (state: IStore) => state.wallet_watchlist.watchedWallets,
    (watchlistWalletss: IWatchedWallet[]): IWatchedWallet | undefined =>
      watchlistWalletss.find((item) => {
        if (data.type === 'overview') {
          return item.wallet_id === data.walletId;
        } else if (data.type === 'traders') {
          return (
            item.address.toLowerCase() === data.address.toLowerCase() &&
            item.chain === data.chain
          );
        }
        return false;
      })
  );
export { createGetFromWatchlist, createGetFromWalletsWatchlist };
